import { render } from "./AddNewsletter.vue?vue&type=template&id=beb9c64c"
import script from "./AddNewsletter.vue?vue&type=script&lang=js"
export * from "./AddNewsletter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__